// extracted by mini-css-extract-plugin
export default {"logo":"LogoImage_logo__k0Ht5"};